import { render, staticRenderFns } from "./ExtrusionFurnaces.vue?vue&type=template&id=56af2f28&"
import script from "./ExtrusionFurnaces.vue?vue&type=script&lang=js&"
export * from "./ExtrusionFurnaces.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionFurnaces.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports